import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";

import Article from "./pages/Article";
import ArticleLists from "./pages/ArticleLists";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { rootReducer } from "./reducers";
import Publish from "./pages/Publish";
import Login from "./pages/Login";
import Account from "./pages/Account";
const persistedState = localStorage.getItem("SessionID")
  ? JSON.parse(localStorage.getItem("SessionID"))
  : {};

// const loadState = () => {
//   try {
//     const serializedState = localStorage.getItem("session");

//     if (serializedState === null) {
//       return undefined;
//     }
//     return JSON.parse(serializedState);
//   } catch (e) {
//     return undefined;
//   }
// };
// const persistedState = loadState();
// const saveState = (key, data) => {
//   try {
//     const serialized = JSON.stringify(data);
//     localStorage.setItem(key, serialized);
//   } catch (error) {}
// };

const store = createStore(
  rootReducer,
  persistedState,
  composeWithDevTools(applyMiddleware(thunk))
);
store.subscribe(() => {
  localStorage.setItem("SessionID", JSON.stringify(store.getState()));
});

// store.subscribe(() => {
//   const state = store.getState();
//   Object.keys(state).forEach((key) => {
//     saveState(key, state[key]);
//   });
// });

function App() {
  return (
    <Router>
      <div className="container">
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <Header />
        <div className="body">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/article/publish" component={Publish} />
            {/* <Route exact path="/about" component={About} /> */}
            <Route path="/articles-list/articles" component={ArticleLists} />
            <Route exact path="/article/:name" component={Article} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/account/articles/:id" component={Account} />
            <Route path="*" component={NotFound} />
            {/* </Suspense> */}
          </Switch>
        </div>
      </div>
    </Router>
  );
}
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
